import Vue from "vue"
import numeral from 'numeral'

Vue.filter('numberFormat', function (value) {
    return numeral(value).format("0,0");
});

Vue.filter('decimalFormat', function (value) {
    return numeral(value).format("0,0.00");
});

export default {

}